// store/modules/i18n.ts
import { Module } from 'vuex'
import { dynamicI18nHandler } from '@/utils/dynamic-i18n'
import {ComposerTranslation} from "vue-i18n";

export interface I18nState {
  messages: Record<string, any>
  baseMessages: Record<string, any>  // 存储基础国际化消息
  aliasConfigs: Array<any>
  isInitialized: boolean
  isBaseLoaded: boolean  //  标记基础消息是否已加载
}

const state: I18nState = {
  messages: {},
  baseMessages: {},      // 初始化为空对象
  aliasConfigs: [],
  isInitialized: false,
  isBaseLoaded: false    // 初始状态为未加载
}

const i18nModule: Module<I18nState, any> = {
  namespaced: true,

  state,

  mutations: {
    SET_MESSAGES(state: I18nState, messages: Record<string, any>) {
      state.messages = messages
    },
    SET_BASE_MESSAGES(state: I18nState, baseMessages: Record<string, any>) {
      console.log("3. SET_BASE_MESSAGES 获取到baseMessages",baseMessages)
      state.baseMessages = baseMessages
      state.isBaseLoaded = true  // 标记基础消息已加载
    },
    SET_ALIAS_CONFIGS(state: I18nState, configs: Array<{ placeholder: string; replaceText: string }>) {
      //console.log("3. SET_ALIAS_CONFIGS 获取到configs",configs)
      state.aliasConfigs = configs
    },
    SET_INITIALIZED(state: I18nState, initialized: boolean) {
      state.isInitialized = initialized
    },
    CLEAR_ALL_CONFIGS(state: I18nState) {
      state.messages = {}
      state.baseMessages = {}
      state.aliasConfigs = []
      state.isInitialized = false
      state.isBaseLoaded = false
    }
  },

  actions: {
    /**
     * 设置基础国际化消息
     */
    setBaseMessages({ commit }, baseMessages: Record<string, any>) {
      console.log("2. setBaseMessages 获取到baseMessages",baseMessages)
      commit('SET_BASE_MESSAGES', baseMessages)
    },

    /**
     * 初始化动态国际化配置
     */
    async initializeDynamicI18n({ commit, state }, payload) {
      try {
        //console.log("7. 》》》 initializeDynamicI18n 获取到payload",payload)
        const { baseLocalText, userConfig } = payload

        // 如果基础消息还没有加载，暂且等待下
        if (!state.isBaseLoaded) {
          let retryCount = 0
          const maxRetries = 10
          while (!state.isBaseLoaded && retryCount < maxRetries) {
            await new Promise(resolve => setTimeout(resolve, 100))
            retryCount++
          }
        }

        // 初始化基础文本信息
        dynamicI18nHandler.initBaseLocalText(baseLocalText)

        // 应用用户配置
        dynamicI18nHandler.updateServerConfig(userConfig)
        //console.log("8. 》》》 initializeDynamicI18n 获取到dynamicI18nHandler.processedMessages",dynamicI18nHandler.processedMessages)
        // 存储处理后的文本信息到Vuex
        commit('SET_MESSAGES', dynamicI18nHandler.processedMessages)
        commit('SET_INITIALIZED', true)
        //console.log("9. 》》》 initializeDynamicI18n SET_INITIALIZED",true)
      } catch (error) {
        console.error('Failed to initialize dynamic i18n:', error)
      }
    }
  },

  getters: {
    t: (state: I18nState) => (key: string, originalT: ComposerTranslation): string => {
      if (!state.isInitialized) return ''

      const keys = key.split('.')
      let result = state.messages
      if (!result || typeof result !== 'object') {
        return originalT(key);
      }
      //console.log("check result",result)
      for (const k of keys) {
        if (result == null || (typeof result !== 'object' && typeof result !== 'function')) {
          return originalT(key)
        }
        result = result[k]
      }

      return  typeof result ==='string' ? result : originalT(key);;
    },
    // 获取指定语言的基础国际化消息
    baseMessages: (state: I18nState) => (lang?: string) => {
      if (lang) {
        return state.baseMessages[lang] || {}
      }
      return state.baseMessages
    },
    // 获取别名配置
    getAliasConfigs: (state: I18nState) => state.aliasConfigs,
    // 检查是否已加载基础消息
    isBaseLoaded: (state: I18nState) => state.isBaseLoaded
  }
}

export default i18nModule
